import { createGaActionCreator } from '../../utils';
import { GaActionText } from './constants';
import { SELECT_PATIENT_GA_CATEGORY } from '../SelectPatient/constants';
import { APPOINTMENT_INFO_GA_CATEGORY } from '../AppointmentInfo/constants';
import { fetchSurvey } from '../../components/Survey/PgsRequests';

const VALIDATE_APPOINTMENT_INFO = '@@reviewAndBook/VALIDATE_APPOINTMENT_INFO';
const VALIDATE_SELECT_PATIENT = '@@reviewAndBook/VALIDATE_SELECT_PATIENT';
const CONTINUE_WAS_CLICKED = '@@reviewAndBook/CONTINUE_WAS_CLICKED';
const HIDE_LOADING_ANIMATION = '@@reviewAndBook/HIDE_LOADING_ANIMATION';
const SHOW_LOADING_ANIMATION = '@@reviewAndBook/SHOW_LOADING_ANIMATION';
const SHOW_MISSING_FIELDS_ERROR = '@@reviewAndBook/SHOW_MISSING_FIELDS_ERROR';
const SHOW_MENTAL_HEALTH_MISSING_ERROR =
    '@@reviewAndBook/SHOW_MENTAL_HEALTH_ERROR';
const CLEAR_MENTAL_HEALTH_MISSING_ERROR =
    '@@reviewAndBook/CLEAR_MENTAL_HEALTH_ERROR';
const SET_MENTAL_HEALTH_QUESTIONNAIRE =
    '@@reviewAndBook/SET_MENTAL_HEALTH_QUESTIONNAIRE';
const TRACK_CLICK_NEW_SUBPATIENT = '@@reviewAndBook/TRACK_CLICK_NEW_SUBPATIENT';
const TRACK_CLICK_EXIT_NEW_SUBPATIENT_MODAL =
    '@@reviewAndBook/TRACK_CLICK_EXIT_NEW_SUBPATIENT_MODAL';
const TRACK_CLICK_EDIT_APPOINTMENT_SUMMARY =
    '@@reviewAndBook/TRACK_CLICK_EDIT_APPOINTMENT_SUMMARY';
const TRACK_CLICK_EXIT_APPOINTMENT_SUMMARY_MODAL =
    '@@reviewAndBook/TRACK_CLICK_EXIT_APPOINTMENT_SUMMARY_MODAL';
const TRACK_CLICK_ADD_PHONE = '@@reviewAndBook/TRACK_CLICK_ADD_PHONE';
const TRACK_CLICK_EDIT_PHONE = '@@reviewAndBook/TRACK_CLICK_EDIT_PHONE';
const TRACK_CLICK_EXIT_PHONE_VERIFICATION_MODAL =
    '@@reviewAndBook/TRACK_CLICK_EXIT_PHONE_VERIFICATION_MODAL';
const TRACK_RESCHEDULE_MODAL = '@@reviewAndBook/TRACK_RESCHEDULE_MODAL';
const TRACK_GTM_CONTAINER = '@@reviewAndBook/TRACK_GTM_CONTAINER';
const FETCH_SURVEY_SUCCEEDED = '@@reviewAndBook/FETCH_SURVEY_SUCCEEDED';

export const ReviewAndBookPageActions = {
    VALIDATE_APPOINTMENT_INFO,
    VALIDATE_SELECT_PATIENT,
    CONTINUE_WAS_CLICKED,
    HIDE_LOADING_ANIMATION,
    SHOW_LOADING_ANIMATION,
    SHOW_MISSING_FIELDS_ERROR,
    SHOW_MENTAL_HEALTH_MISSING_ERROR,
    CLEAR_MENTAL_HEALTH_MISSING_ERROR,
    SET_MENTAL_HEALTH_QUESTIONNAIRE,
    TRACK_CLICK_NEW_SUBPATIENT,
    TRACK_CLICK_EXIT_NEW_SUBPATIENT_MODAL,
    TRACK_CLICK_EDIT_APPOINTMENT_SUMMARY,
    TRACK_CLICK_EXIT_APPOINTMENT_SUMMARY_MODAL,
    TRACK_CLICK_ADD_PHONE,
    TRACK_CLICK_EDIT_PHONE,
    TRACK_CLICK_EXIT_PHONE_VERIFICATION_MODAL,
    TRACK_RESCHEDULE_MODAL,
    TRACK_GTM_CONTAINER,
    FETCH_SURVEY_SUCCEEDED,
};

export const validateAppointmentInfo = () => ({
    type: VALIDATE_APPOINTMENT_INFO,
});

export const validateSelectPatient = () => ({
    type: VALIDATE_SELECT_PATIENT,
});

export const continueWasClicked = () => ({
    type: CONTINUE_WAS_CLICKED,
});

export const hideLoadingAnimation = () => ({
    type: HIDE_LOADING_ANIMATION,
});

export const showLoadingAnimation = () => ({
    type: SHOW_LOADING_ANIMATION,
});

export const showMissingFieldsError = () => ({
    type: SHOW_MISSING_FIELDS_ERROR,
});

export const showMentalHealthMissingError = () => ({
    type: SHOW_MENTAL_HEALTH_MISSING_ERROR,
});

export const clearMentalHealthMissingError = () => ({
    type: CLEAR_MENTAL_HEALTH_MISSING_ERROR,
});

export const setMentalHealthQuestionnaire = value => ({
    type: SET_MENTAL_HEALTH_QUESTIONNAIRE,
    value: value,
});

export const trackClickNewSubpatient = () =>
    createGaActionCreator(
        TRACK_CLICK_NEW_SUBPATIENT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackClickNewSubpatient
    );

export const trackClickExitNewSubpatientModal = () =>
    createGaActionCreator(
        TRACK_CLICK_EXIT_NEW_SUBPATIENT_MODAL,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackClickExitNewSubpatientModal
    );

export const trackClickExitRescheduleModal = () =>
    createGaActionCreator(
        TRACK_RESCHEDULE_MODAL,
        APPOINTMENT_INFO_GA_CATEGORY,
        GaActionText.trackClickRescheduleModal
    );

export const trackFinishedRescheduleModal = () =>
    createGaActionCreator(
        TRACK_RESCHEDULE_MODAL,
        APPOINTMENT_INFO_GA_CATEGORY,
        GaActionText.trackFinishedRescheduleModal
    );

export const trackViewedRescheduleModal = () =>
    createGaActionCreator(
        TRACK_RESCHEDULE_MODAL,
        APPOINTMENT_INFO_GA_CATEGORY,
        GaActionText.trackViewedRescheduleModal
    );

export const trackGtmContainerLoad = () =>
    createGaActionCreator(
        TRACK_GTM_CONTAINER,
        APPOINTMENT_INFO_GA_CATEGORY,
        GaActionText.trackGtmContainerLoad
    );

export const trackClickAddPhone = () => {
    return dispatch => {
        dispatch(
            createGaActionCreator(
                TRACK_CLICK_ADD_PHONE,
                APPOINTMENT_INFO_GA_CATEGORY,
                GaActionText.trackClickAddPhone
            )
        );
    };
};

export const trackClickEditPhone = () => {
    return dispatch => {
        dispatch(
            createGaActionCreator(
                TRACK_CLICK_EDIT_PHONE,
                APPOINTMENT_INFO_GA_CATEGORY,
                GaActionText.trackClickEditPhone
            )
        );
    };
};

export const trackClickExitPhoneVerificationModal = () =>
    createGaActionCreator(
        TRACK_CLICK_EXIT_PHONE_VERIFICATION_MODAL,
        APPOINTMENT_INFO_GA_CATEGORY,
        GaActionText.trackClickExitPhoneVerificationModal
    );

export const fetchSurveyAction = bookingId => {
    return async dispatch => {
        const surveyData = await fetchSurvey(bookingId);
        dispatch({
            type: FETCH_SURVEY_SUCCEEDED,
            payload: surveyData,
        });
    };
};

export const ReviewAndBookPageTrackingActionCreators = {
    trackClickExitPhoneVerificationModal,
    trackClickExitNewSubpatientModal,
    trackClickNewSubpatient,
    trackClickAddPhone,
    trackClickEditPhone,
    trackClickExitRescheduleModal,
    trackFinishedRescheduleModal,
    trackViewedRescheduleModal,
    trackGtmContainerLoad,
    fetchSurveyAction,
};
